module.exports = __webpack_public_path__ + "img/ElectricNotrun.79d7a7a3.svg";